import { ResponseModel } from "../models/ResponseModel";
import { AjaxService } from "../shared/services/AjaxService";


export const TimeBasedService = {

    async getEnumeration(code: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/Enumeration/getEnumeration?code=${encodeURIComponent(code)}`);
    },


    getWorshipAgainstDate(payload: { date: string; worshipType: string }): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/Worship/getWorshipAgainstDate", payload);
    },

    create(payload: any): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/Worship/create", payload);
    },

    getWorshipHistory(payload: {fromDate: string; toDate: string; userId: string, worshipType: string }): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>("/Worship/getWorshipHistory", payload);
    },

    delete(worshipId: string): Promise<ResponseModel> {
        return AjaxService.delete<ResponseModel>(`/Worship/delete?worshipId=${encodeURIComponent(worshipId)}`);
    },

    async getWorship(worshipId: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(`/Worship/getWorship?worshipId=${encodeURIComponent(worshipId)}`);
    },
}